import { render, staticRenderFns } from "./mobileFooter.vue?vue&type=template&id=168d2cb7&"
import script from "./mobileFooter.vue?vue&type=script&lang=js&"
export * from "./mobileFooter.vue?vue&type=script&lang=js&"
import style0 from "./mobileFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports